import type { components } from "@/api/schema";

export type DiffRow = components["schemas"]["InventoryDiffRow"];

export type DiffSortKey =
  | "sku"
  | "expect_quantity"
  | "real_quantity"
  | "diff"
  | "pct"
  | "snapshot_at";
export type SortDir = "asc" | "desc";

export interface DiffFilterState {
  search: string;
  /** Spec D5's "Only over threshold" toolbar filter. Default on. */
  overOnly: boolean;
  sortKey: DiffSortKey;
  sortDir: SortDir;
  offset: number;
  limit: number;
}

export const DEFAULT_LIMIT = 50;

export function defaultDiffFilter(overOnly = true): DiffFilterState {
  return { search: "", overOnly, sortKey: "pct", sortDir: "desc", offset: 0, limit: DEFAULT_LIMIT };
}

export function filterToQuery(f: DiffFilterState): {
  search?: string;
  over_only?: boolean;
  sort_key: DiffSortKey;
  sort_dir: SortDir;
  offset: number;
  limit: number;
} {
  const q: {
    search?: string;
    over_only?: boolean;
    sort_key: DiffSortKey;
    sort_dir: SortDir;
    offset: number;
    limit: number;
  } = {
    sort_key: f.sortKey,
    sort_dir: f.sortDir,
    offset: f.offset,
    limit: f.limit,
  };
  if (f.search) q.search = f.search;
  // Omitted when off: the API default is "every row", so an absent param and
  // over_only=false mean the same thing and the shorter URL wins.
  if (f.overOnly) q.over_only = true;
  return q;
}

export function toggleSort(f: DiffFilterState, key: DiffSortKey): DiffFilterState {
  if (f.sortKey === key) return { ...f, sortDir: f.sortDir === "asc" ? "desc" : "asc", offset: 0 };
  return { ...f, sortKey: key, sortDir: "desc", offset: 0 };
}
